import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";

import temsLogo from "../../../../assets/img/clients/tems-cropped.webp";

export default function TemsTiger() {
    const caseStudy = new CaseStudyTemplate(
        "TEMS Tiger",
        (
            <div>
                <p>
                    A new module to enhance the TEMS suite of cloud-based applications.  TEMS International identified a requirement and a gap in the market for an additional cloud-based service to reduce the environmental impact of waste management during the offshore drilling process.  The TIGER reporting system automates complex calculations and delivers instant real-time reports.
                </p>
                <p>
                    The TIGER application has been built using Progressive Web Application (PWA) Technologies to optimise it for working on mobile devices and for offline use in restricted WiFi areas.
                </p>
            </div>
        ),
        // Project Showcase Thumbnail
        "https://around.createx.studio/assets/img/portfolio/list/06.png",
        new Company(
            "TEMS",
            // Company Logo
            temsLogo
        ),
        "https://tems-international.com/tems-international-services/tems-international-eagle-reports",
        [
            technologies.PWA,
            technologies.netCore,
            technologies.blazor,
            technologies.sqlServer,
            technologies.azure
        ]
    )

    return (
        <CaseStudy caseStudy={caseStudy}></CaseStudy>
    )
}